import { render, staticRenderFns } from "./coupon-storage-modal.vue?vue&type=template&id=2bb3ae06&scoped=true&"
import script from "./coupon-storage-modal.vue?vue&type=script&lang=js&"
export * from "./coupon-storage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3ae06",
  null
  
)

export default component.exports